import { Button as Button, Dropdown as Dropdown, ScrollSpy as ScrollSpy, Tab as Tab, Collapse as Collapse } from 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import Swiper, { Autoplay, Navigation, Pagination, Scrollbar, EffectFade, Mousewheel } from "swiper";
Swiper.use([Autoplay, Navigation, Pagination, Scrollbar, EffectFade, Mousewheel]);
import "swiper/swiper-bundle.css";

import InfiniteScroll from "infinite-scroll";

import AOS from "aos";
import "aos/dist/aos.css";

import Rellax from "rellax";

import './styles.scss';

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 250) {
      document.getElementById("header").classList.add("scrolled");
      document.getElementById("header").classList.remove("closed");
    } else {
      document.getElementById("header").classList.remove("scrolled");
      document.getElementById("header").classList.remove("closed");
    }
  });
});

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

$( document ).ready( function() {
  $(".burger-button").on("click touch", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $("header").toggleClass("open");
    $(".header-center").toggleClass("active");
  });

  $(".close-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-center").removeClass("active");
  });


  if (
    $(".articles-list-container").length > 0 &&
    $(".pagination").length > 0
  ) {

    let elem = document.querySelector(".articles-list-container");

    let infScroll = new InfiniteScroll(elem, {
      // options
      path: ".pagination a",
      append: ".article-container",
      history: false,
      loadOnScroll: false
    });

    var $viewMoreButton = $(".pagination a");

    $viewMoreButton.on("click", function (e) {
      e.preventDefault();
      infScroll.loadNextPage();
    });

    infScroll.on("last", function (event, response, path) {
      $(".pagination").hide();
    });
  }


  if (window.location.hash) {
    var target = window.location.hash;
    $("html, body").animate({ scrollTop: $(target).offset().top - 82 }, 0);
  }

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("header").removeClass("open");
          $(".burger .burger-button").removeClass("active");
          $(".header-center").removeClass("active");

          $("html, body").animate(
            { scrollTop: $(target).offset().top - 82 },
            0
          );
          return false;
        }
      }
    });
  });

  $(".anchor").on("click touch", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    if ($(target).length > 0) {
      $("html, body").animate({ scrollTop: $(target).offset().top - 82 }, 0);
      return false;
    } else {
      $("html, body").animate({ scrollTop: $("#footer").offset().top - 82 }, 0);
      return false;
    }
  });

  const buildSwiperSlider = (sliderElm) => {
    const sliderIdentifier = sliderElm.dataset.id;
    if (
      $("#" + sliderIdentifier).length > 0 &&
      $("#" + sliderIdentifier + " .swiper-slide").length > 1
    ) {
      return new Swiper(`#${sliderElm.id}` + " .swiper", {
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: `#${sliderElm.id}` + " .swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      });
    } else {
      $("#" + sliderIdentifier + " .swiper-button").hide();
    }
  };

  const allSliders = document.querySelectorAll(
    ".header_block .swiper-container"
  );
  allSliders.forEach((slider) => buildSwiperSlider(slider));

  var headerSwiper = new Swiper(".header_slider_block .swiper", {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    speed: 1200,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: ".header_slider_block .swiper-button-prev",
      nextEl: ".header_slider_block .swiper-button-next",
    },
  });

  var stockistsSwiper = new Swiper(".stockists_slider_block .swiper", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 60,
    allowTouchMove: false,
    speed: 5000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
  });

  var testimonialsSwiper = new Swiper(".testimonials_slider_block .swiper", {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1200,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: ".testimonials_slider_block .swiper-button-prev",
      nextEl: ".testimonials_slider_block .swiper-button-next",
    },
  });

  
  

  const buildCompareSwiperSlider = (sliderElm) => {
    const sliderIdentifier = sliderElm.dataset.id;
    if (
      $("#" + sliderIdentifier).length > 0 &&
      $("#" + sliderIdentifier + " .swiper-slide").length > 1
    ) {
      return new Swiper(`#${sliderElm.id}` + " .swiper", {
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        speed: 1000,
        customFraction: true,
        navigation: {
          prevEl: `#${sliderElm.id}` + " .swiper-button-prev",
          nextEl: `#${sliderElm.id}` + " .swiper-button-next",
        },
      });
    } else {
      $("#" + sliderIdentifier + ' .swiper-button').hide(0);
    }
  };

  const allCompareSliders = document.querySelectorAll(
    ".compare_block .swiper-container"
  );
  allCompareSliders.forEach((slider) => buildCompareSwiperSlider(slider));



  $("header li.menu-item-has-children > a").on("click touch", function (e) {
    e.preventDefault();
    $(this).parent("li").toggleClass("active");
    $(this).parent("li").find(".sub-menu").slideToggle(500);
  });

  if ($(".calorie_counter").length > 0) {
    var increment = $(".calorie_counter").data("increment");
    setInterval(function () {
      var total = $(".calorie_counter").text();
      total = parseInt(total.replace(/\,/g, "")) + increment;
      total = total.toLocaleString("en");
      $(".calorie_counter").empty().text(total);
    }, 1000);
  }

  $(".read-more").on("click touch", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    if( $( this ).hasClass( "active" ) ) {
      $( this ).empty().text( 'Read Less');
    } else {
      $(this).empty().text("Read More");
    }
    $(this).parents(".content").find(".read-more-content").slideToggle(500);    
  });

  
  $(".pages_block .icon.hover-link").on("click touch", function (e) {
    e.preventDefault();
    if (!$(this).hasClass("active")) {
      var target = $(this).attr("href");
      $(this)
        .parents(".pages_block")
        .find(".icon.active")
        .removeClass("active");
      $(this).addClass("active");
      $(this)
        .parents(".pages_block")
        .find(".page-content-inner.active")
        .fadeOut(1)
        .removeClass("active");
      $(target).fadeIn(500).addClass("active");
    }
  });
  
  // init Isotope
  var $grid = $(".isotope-grid").isotope({
    itemSelector: ".isotope-grid-item",
  });

  var $grid;
  var filters = {};
  $('.stockists_block .filter a.active' ).each( function() {
    manageFilter($( this ));
  })

  $(function () {
    $grid = $(".isotope-grid");
    $grid.isotope({
      itemSelector: ".isotope-grid-item",
    });
    // do stuff when checkbox change
    $(".stockists_block .filter a").on("click touch", function (e) {
      e.preventDefault();
      $( this ).toggleClass( 'active' );
      manageFilter($( this ));
      var comboFilter = getComboFilter(filters);
      $grid.isotope({ filter: comboFilter });
    });
  });

  function getComboFilter(filters) {
    var i = 0;
    var comboFilters = [];
    var message = [];

    for (var prop in filters) {
      message.push(filters[prop].join(" "));
      var filterGroup = filters[prop];
      // skip to next filter group if it doesn't have any values
      if (!filterGroup.length) {
        continue;
      }
      if (i === 0) {
        // copy to new array
        comboFilters = filterGroup.slice(0);
      } else {
        var filterSelectors = [];
        // copy to fresh array
        var groupCombo = comboFilters.slice(0); // [ A, B ]
        // merge filter Groups
        for (var k = 0, len3 = filterGroup.length; k < len3; k++) {
          for (var j = 0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
          }
        }
        // apply filter selectors to combo filters for next group
        comboFilters = filterSelectors;
      }
      i++;
    }

    var comboFilter = comboFilters.join(", ");
    return comboFilter;
  }

  function manageFilter($filter) {

    var group = $filter.parents(".filter").attr("data-filter-group");
    // create array for filter group, if not there yet
    var filterGroup = filters[group];
    if (!filterGroup) {
      filterGroup = filters[group] = [];
    }

    var index = $.inArray($filter.data("term"), filterGroup);

    if ($filter.hasClass("active")) {
      if (index === -1) { 
        filters[group].push($filter.data("term"));
      }
    } else {
      filters[group].splice(index, 1);
    }
  }


  $(".tab-nav a").on("click", function (event) {
    event.preventDefault();
    let tab = $(this).attr("href");
    $(this).parents(".tab-nav").find(".button").removeClass("active");
    $(".tab").fadeOut(0);
    $(tab).fadeIn();
    $(this).addClass("active");
    $(this).parents(".tab-nav").removeClass("active");
  });

  $(".video-popup").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });


  if ($(".rellax").length > 0) {
    var rellax = new Rellax(".rellax", {
      center: true,
    });
  }

  AOS.init({
    offset: 40, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1200, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
  });
});
